import { RouteRecordRaw } from "vue-router";
import { PAGE_TYPE } from "@supplier/meta";

export const logisticsRouter: RouteRecordRaw[] = [
    {
        path: "logistics",
        component: () => import("@/views/layouts/index.vue"),
        redirect: "/logistics/shipOrder",
        name: "Logistics",
        meta: {
            title: "物流管理"
        },
        children: [
            {
                path: "shipOrder",
                name: "ShipOrder",
                component: () => import("@/views/pages/logisticsManagement/shipOrder/index.vue"),
                meta: {
                    title: "船运单管理",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "shipOrder/add",
                name: "ShipOrderAdd",
                component: () => import("@/views/pages/logisticsManagement/shipOrder/form.vue"),
                meta: {
                    title: "新增船运单",
                    hidden: true,
                    activeMenu: "ShipOrder",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "shipOrder/detail",
                name: "ShipOrderDetail",
                component: () => import("@/views/pages/logisticsManagement/shipOrder/detail.vue"),
                meta: {
                    title: "船运单详情",
                    hidden: true,
                    activeMenu: "ShipOrder",
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "shipOrder/edit",
                name: "ShipOrderEdit",
                component: () => import("@/views/pages/logisticsManagement/shipOrder/offlineForm.vue"),
                meta: {
                    title: "修改船运单",
                    hidden: true,
                    activeMenu: "ShipOrder",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "transportOrderVehicle",
                name: "TransportOrderVehicle",
                component: () => import("@/views/pages/logisticsManagement/transportOrderVehicle/index.vue"),
                meta: {
                    title: "汽运单管理",
                    activeMenu: "TransportOrderVehicle",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "transportOrderVehicle/detail",
                name: "TransportOrderVehicleDetail",
                component: () => import("@/views/pages/logisticsManagement/transportOrderVehicle/detail.vue"),
                meta: {
                    title: "汽运单详情",
                    hidden: true,
                    activeMenu: "TransportOrderVehicle",
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "transportOrderVehicle/add",
                name: "TransportOrderVehicleAdd",
                component: () => import("@/views/pages/logisticsManagement/transportOrderVehicle/form.vue"),
                meta: {
                    title: "新增汽运单",
                    hidden: true,
                    activeMenu: "TransportOrderVehicle",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "transportOrderVehicle/edit",
                name: "TransportOrderVehicleEdit",
                component: () => import("@/views/pages/logisticsManagement/transportOrderVehicle/form.vue"),
                meta: {
                    title: "修改汽运单",
                    hidden: true,
                    activeMenu: "TransportOrderVehicle",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "railwayOrder",
                name: "RailwayOrder",
                component: () => import("@/views/pages/logisticsManagement/railwayOrder/index.vue"),
                meta: {
                    title: "铁路单管理",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "railwayOrder/detail",
                name: "RailwayOrderDetail",
                component: () => import("@/views/pages/logisticsManagement/railwayOrder/detail.vue"),
                meta: {
                    title: "铁路单详情",
                    hidden: true,
                    activeMenu: "RailwayOrder",
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "railwayOrder/add",
                name: "RailwayOrderAdd",
                component: () => import("@/views/pages/logisticsManagement/railwayOrder/form.vue"),
                meta: {
                    title: "新增铁路单",
                    hidden: true,
                    activeMenu: "RailwayOrder",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "railwayOrder/edit",
                name: "RailwayOrderEdit",
                component: () => import("@/views/pages/logisticsManagement/railwayOrder/form.vue"),
                meta: {
                    title: "修改铁路单",
                    hidden: true,
                    activeMenu: "RailwayOrder",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            }
        ]
    }
];

export default logisticsRouter;
